<main class="login-page">
  <section class="login-card" aria-label="Admin login">
    <a routerLink="/" class="login-brand" aria-label="Back to S.R.Organic home">
      <span aria-hidden="true">🍄</span>
      <strong>S.R.ORGANIC</strong>
    </a>

    <p class="login-eyebrow">Admin Access</p>
    <h1>Manage product streams with confidence.</h1>
    <p class="login-copy">Sign in to update the public carousel, product details, and family items.</p>

    <form [formGroup]="loginForm" (ngSubmit)="submit()">
      <label>
        Email
        <input type="email" formControlName="email" autocomplete="username" placeholder="admin@srorganic.com" />
        <small *ngIf="loginForm.controls.email.touched && loginForm.controls.email.invalid">
          Enter a valid admin email.
        </small>
      </label>

      <label>
        Password
        <input type="password" formControlName="password" autocomplete="current-password" placeholder="Password" />
        <small *ngIf="loginForm.controls.password.touched && loginForm.controls.password.invalid">
          Enter your password.
        </small>
      </label>

      <p *ngIf="loginError" class="login-error">{{ loginError }}</p>

      <button type="submit" [disabled]="isSubmitting">
        {{ isSubmitting ? 'Signing in...' : 'Login to Dashboard' }} <span aria-hidden="true">→</span>
      </button>
    </form>
  </section>
</main>
